import React, { useState } from 'react';

function buildDestinationUrl(baseUrl, utm) {
  const params = new URLSearchParams();
  if (utm?.source) { params.set('utm_source', utm.source); }
  if (utm?.medium) { params.set('utm_medium', utm.medium); }
  if (utm?.campaign) { params.set('utm_campaign', utm.campaign); }
  if (utm?.content) { params.set('utm_content', utm.content); }
  const qs = params.toString();
  return qs ? `${baseUrl}?${qs}` : baseUrl;
}

export default function SignupRequestView({ questionText, options, utm, destinationUrl, onSelect }) {
  const [submitting, setSubmitting] = useState(false);

  const sortedOptions = [...(options || [])].sort((a, b) => a.displayOrder - b.displayOrder);
  const responseValue = sortedOptions[0]?.responseValue || 'signup_request';
  const buttonLabel = sortedOptions[0]?.buttonLabel || 'Sign Up Now';
  const destination = buildDestinationUrl(destinationUrl || '/guides/signup', utm);

  async function handleClick() {
    setSubmitting(true);
    await onSelect(responseValue);
    window.location.href = destination;
  }

  return (
    <div className="bg-white rounded-lg shadow-sm p-8 text-center">
      {questionText && (
        <h1 className="text-xl font-semibold text-gray-900 mb-4">{questionText}</h1>
      )}

      <p className="text-gray-600 mb-6">
        Join our community of outdoor guides and start leading adventures today.
      </p>

      <button
        onClick={handleClick}
        disabled={submitting}
        className="w-full min-h-[44px] px-6 py-3 bg-violet-600 text-white font-medium rounded-lg hover:bg-violet-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {submitting ? 'Redirecting...' : buttonLabel}
      </button>
    </div>
  );
}
